import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uiActions from 'tradera-state/ui/actions';
import RadioSwitch from 'tradera-components/form-controls/radio-switch';
import useIsMobile from 'tradera-hooks/use-is-mobile';

import * as gtm from 'tradera-apps/tradera/components/discover/helpers/search-gtm';
import ListViewIcon from '@tradera/blueprint/theme/icons2/view-list.svg?jsx';
import GridSmallIcon from '@tradera/blueprint/theme/icons2/view-sm.svg?jsx';
import GridMediumIcon from '@tradera/blueprint/theme/icons2/view-md.svg?jsx';
import GridLargeIcon from '@tradera/blueprint/theme/icons2/view-lg.svg?jsx';

const trackItemLayoutChange = itemLayout => {
    gtm.trackFilter('Layout', itemLayout);
};

const ItemLayoutSwitch = ({ itemLayout, className, id, updateItemLayout }) => {
    const showSmallOption = !useIsMobile();

    const options = [
        {
            value: 'layout-list',
            name: (
                <span>
                    <ListViewIcon className="icon align-text-bottom" />
                </span>
            )
        },
        showSmallOption
            ? {
                  value: 'layout-grid',
                  name: (
                      <span>
                          <GridSmallIcon className="icon align-text-bottom" />
                      </span>
                  )
              }
            : {},
        {
            value: 'layout-grid-medium',
            name: (
                <span>
                    <GridMediumIcon className="icon align-text-bottom" />
                </span>
            )
        },
        {
            value: 'layout-grid-large',
            name: (
                <span>
                    <GridLargeIcon className="icon align-text-bottom" />
                </span>
            )
        }
    ];

    return (
        <RadioSwitch
            id={id}
            options={options}
            checked={itemLayout}
            handleOnChange={e => {
                updateItemLayout(e);
                trackItemLayoutChange(e);
            }}
            className={className}
        />
    );
};

ItemLayoutSwitch.propTypes = {
    itemLayout: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string.isRequired
};

const mapStateToProps = state => {
    return {
        itemLayout: state.ui.itemLayout
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateItemLayout: itemLayout =>
            dispatch(uiActions.updateItemLayout(itemLayout))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemLayoutSwitch);
